import React from 'react'
import { useTranslation } from 'react-i18next'

import { useChecklistFormActions } from '../../../_form/ChecklistFormHandler'
import { useIsDraggingType } from '../../../../../../components/dnd/DndHandler'
import AddConditionsMenuItem from '../conditions/AddConditionsMenuItem'
import FloatingMenu, { FloatingMenuItem } from '../../../../../../packages/kiti/components/navigation/FloatingMenu'
import Line from '../../../../../../packages/kiti/components/helpers/Line'
import dndTypes from '../../_constants/dndTypes'
import RemoveModal from '../removeModal/RemoveModal'

const QuestionMenu = ({ open, questionId }) => {
  const { t } = useTranslation('editChecklist')
  const { duplicateSelectedQuestion, openTriggersQuestionCheckModal } = useChecklistFormActions()
  const isDragging = useIsDraggingType(dndTypes.QUESTION)

  if (!open || isDragging) return false

  return (
    <>
      <FloatingMenu top={-2.6} left={-3.4}>
        <AddConditionsMenuItem />
        <FloatingMenuItem onClick={duplicateSelectedQuestion} label={t('clone')} icon="BsLayers" color="dark3" />
        <Line />
        <FloatingMenuItem onClick={openTriggersQuestionCheckModal} label={t('remove')} icon="BsTrash" color="red" />
      </FloatingMenu>
      <RemoveModal questionIds={[questionId]} />
    </>
  )
}

export default QuestionMenu
